import * as Styles from './_styles/logout.styled'
import {LogOut} from 'react-feather'
import {loggingOut} from '../../../../store/state/session-data/action-creators'
import {useDispatch} from 'react-redux'
import {useQueryClient} from '@tanstack/react-query'

import type {JSX} from 'react'

export function Logout(): JSX.Element {
    const dispatch = useDispatch()

    const qClient = useQueryClient()

    function onClick() {
        dispatch(loggingOut())
        // Clear all data from tanstack
        qClient.clear()
    }

    return (
        <Styles.Button id="logout-button" onClick={onClick}>
            <LogOut />
        </Styles.Button>
    )
}
